<mat-toolbar color="accent">
  <span>Select Patient Files</span>
</mat-toolbar>

<mat-dialog-content>
  <pr-media-manager
    [media]="data.media"
    [patient]="data.patient"
    (mediaSelectionChange)="selectedMediaItems.set($event)"
  />
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!selectedMediaItems().length"
      (click)="dialogRef.close(selectedMediaItems())"
    >
      Add Files
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
